import { API_BASE_URL } from '../api';

function buildMessagesRealtimeUrl(apiBaseUrl = API_BASE_URL, token = '') {
  const url = new URL(apiBaseUrl);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  url.pathname = `${url.pathname.replace(/\/$/, '')}/messages/realtime`;
  url.search = '';
  url.searchParams.set('token', token);
  return url.toString();
}

function connectMessagesRealtime({
  apiBaseUrl = API_BASE_URL,
  token,
  onEvent,
  onStatus,
} = {}) {
  if (!token || typeof WebSocket === 'undefined') return () => {};

  const socket = new WebSocket(buildMessagesRealtimeUrl(apiBaseUrl, token));
  socket.addEventListener('open', () => onStatus?.('open'));
  socket.addEventListener('close', () => onStatus?.('closed'));
  socket.addEventListener('error', () => onStatus?.('error'));
  socket.addEventListener('message', event => {
    try {
      onEvent?.(JSON.parse(event.data));
    } catch {
      onStatus?.('invalid-message');
    }
  });

  return () => socket.close();
}

export { buildMessagesRealtimeUrl, connectMessagesRealtime };
